// client.ts
import createClient from 'openapi-fetch';
import type { paths } from './types/api';
import { Auth } from 'aws-amplify';
import apiEndpoints from "../apiEndpoints";

const BASE_URL = apiEndpoints.NEST_BASE_URL;

async function getValidToken() {
  // Amplify automatically refreshes token internally
  const session = await Auth.currentSession();
  return session.getAccessToken().getJwtToken();
}

export const client = createClient<paths>({
  baseUrl:BASE_URL,


  fetch: async (url) => {
    let token = await getValidToken();
    let response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (response.status === 401) {
      const newToken = await getValidToken();
      return fetch(url, {
        headers: {
          Authorization: `Bearer ${newToken}`,
          'Content-Type': 'application/json',
        },
      });
    }
    // if (!response.ok) {
    //   const body = await response.text().catch(() => '');
    //   throw new Error(`HTTP ${response.status} ${response.statusText}: ${body || 'Unknown error'}`);
    // }
    if (!response.ok) {
      const bodyText = await response.text().catch(() => '');

      let errorMessage = bodyText;
      
      const json = JSON.parse(bodyText);
      errorMessage = json.message || json.error || bodyText;
      let cause = {
        cause: json.error 
      };
      throw new Error(errorMessage, cause);
    }
    return response;
  },
});
